










































// Vue
import { computed, defineComponent, PropType, ref, Ref } from '@vue/composition-api'

// components
import { Input, Radio, Select } from '@/components/form'

// Vuelidate
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// models
import { ReasonForTerminationWorkForm } from '@/models/config'
import { PropOptionSelect } from '@/models'

// constants
import { optionsStatus } from '@/constants'

// utils
import { loading, alerts } from '@/utils'

// services
import { ReasonForTerminationWorkService } from '@/services/config'

const initItem: ReasonForTerminationWorkForm = {
    name: '',
    is_active: true
}
export default defineComponent({
    name: 'FormCreateEditReasonForTerminationWork',
    components: {
        Input,
        Radio,
        Select
    },
    props: {
        actionForm: {
            type: String as PropType<string>,
            default: 'save'
        },
        reason: {
            type: Object as PropType<ReasonForTerminationWorkForm>,
            required: true
        },
        idEdit: {
            type: Number as PropType<number>,
            default: false
        }
    },
    setup (props, { emit }) {
        const opStatus = ref(optionsStatus)
        const form: Ref<ReasonForTerminationWorkForm> = (props.idEdit) ? ref({
            ...props.reason
        }) : ref({
            is_active: true,
            name: ''
        })
        const options = computed((): PropOptionSelect[] => {
            return [
                {
                    text: 'Con Goce de Haber',
                    value: 'Con Goce de Haber'
                },
                {
                    text: 'Sin Goce de Haber',
                    value: 'Sin Goce de Haber'
                }
            ]
        })
        const rules = computed(() => ({
            name: { required },
            is_active: { required }
        }))

        const $v = useVuelidate(rules, form.value)
        const save = async () => {
            $v.value.$touch()
            if ($v.value.$errors) {
                loading('show')
                try {
                    if (props.actionForm === 'update' && props.idEdit !== null) {
                        await ReasonForTerminationWorkService.update(props.idEdit, form.value)
                    } else {
                        await ReasonForTerminationWorkService.create(form.value)
                    }
                    alerts.success()
                    $v.value.$reset()
                    form.value = initItem
                    emit('save-success')
                } catch (e) {
                    alerts.error('Se ha presentado errores en la operación')
                }
                loading('hide')
                $v.value.$reset()
            } else {
                alerts.error('Debe completar todos los campos requeridos')
            }
            loading('hide')
        }
        return {
            opStatus,
            form,
            options,
            $v,
            save
        }
    }
})
